/* eslint-disable */

/** unique or primary key constraints on table "argo.work_order_material" */
export enum ArgoWorkOrderMaterialConstraint {
  /** unique or primary key constraint on columns "material_id" */
  WorkOrderMaterialOne = 'work_order_material_one',
  /** unique or primary key constraint on columns "work_order_material_id" */
  WorkOrderMaterialPkey = 'work_order_material_pkey'
}

/** select columns of table "argo.work_order_material" */
export enum ArgoWorkOrderMaterialSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkOrderId = 'work_order_id'
}

/** update columns of table "argo.work_order_material" */
export enum ArgoWorkOrderMaterialUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkOrderId = 'work_order_id'
}

